import { Component } from '@angular/core';

@Component({
  selector: 'app-compress-pd-content',
  imports: [],
  templateUrl: './compress-pd-content.component.html',
  styleUrl: './compress-pd-content.component.css'
})
export class CompressPdContentComponent {

}
